module.exports = __webpack_public_path__ + "img/about-luca.png?bfe8df5a6383089f5d8d63745cb91530";